import { Anchor } from '@components/Anchor';
import { LinkText } from '@components/LinkText';
import { Pagination } from '@components/Table/Pagination';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableNoResult } from '@components/Table/TableNoResult';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { useModalWindow } from '@hooks/useModalWindow';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IInadimplenciaFilter, IInadimplenciaRecord } from '@services/RelatorioService';
import React from 'react';
import { InadimplenciaDetalhesModal } from './InadimplenciaDetalhesModal';

export type InadimplenciaTableProps = {
    data: IData<IInadimplenciaRecord, IInadimplenciaFilter>
    isLoading: boolean
}

export function InadimplenciaTable ({ data, isLoading }: InadimplenciaTableProps) {
    const formatter = useFormatter();
    const detalhesModal = useModalWindow();

    return (
        <React.Fragment>
            <TableNoResult itemCount={data.itemsCount}>
                <TableHead>
                    <Pagination pagination={data.pagination} />

                    <TableSortRow sort={data.sort}>
                        <TableSortCell fieldName="clienteId">ID</TableSortCell>
                        <TableSortCell fieldName="nome">Nome</TableSortCell>
                        <TableSortCell fieldName="cpf">Documento</TableSortCell>
                        <TableSortCell fieldName="inadimplenciaTotal">Total</TableSortCell>
                    </TableSortRow>
                </TableHead>
                
                <TableBody>
                    {
                        data.items.map((inadimplenciaRecord, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableKeyCell>{inadimplenciaRecord.clienteId}</TableKeyCell>
                                    <TableCell><LinkText to={`/cliente/${inadimplenciaRecord.clienteId}`} text={inadimplenciaRecord.nome} /></TableCell>
                                    <TableCell>{inadimplenciaRecord.cpf}</TableCell>
                                    <TableCell><Anchor onClick={data.handleRowFocused(inadimplenciaRecord, detalhesModal.open)}>{formatter.toFloat(inadimplenciaRecord.inadimplenciaTotal)}</Anchor></TableCell>
                                </TableRow>
                            )
                        })
                    }

                    <Pagination pagination={data.pagination} />

                </TableBody>
            </TableNoResult>

            {
                data.focusedRow !== undefined && (
                    <InadimplenciaDetalhesModal 
                        modal={detalhesModal}
                        cliente={data.focusedRow}
                    />
                )
            }
        </React.Fragment>
    )
}